import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import Overview from '../Overview/Overview';
import Devices from '../Devices/Devices';
import ClaimDevice from '../Devices/ClaimDevice';
import DeviceDetail from '../Devices/DeviceDetail';
import Projects from '../Projects/Projects';
import AddProject from '../Projects/AddProject';
import ProjectDetailPage from '../Projects/ProjectDetailPage';
import Download from '../Download/Download';
import classes from './MainPage.module.css';

const MainPage = ({ user, onLogout }) => {
  return (
    <div className={classes.pageContainer}>
      <Sidebar />
      <div className={classes.content}>
        <Routes>
          <Route path="/overview" element={<Overview />} />
          <Route path="/devices" element={<Devices />} />
          <Route path="/devices/claim-device" element={<ClaimDevice />} />
          <Route path="/devices/:id" element={<DeviceDetail />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/add-project" element={<AddProject />} />
          <Route path="/download" element={<Download />} />
          <Route path="/project/:id" element={<ProjectDetailPage />} />
          <Route path="/" element={<Navigate to="/overview" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default MainPage;


